var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable */
import React, { useRef, useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { pdfjs } from 'react-pdf';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Tesseract, { createWorker } from 'tesseract.js';
import Service from '../../services/Service';
import * as FormActions from '../../store/form/actions';
import useOrientation from '../../util/useOrientation';
import CameraError from '../CameraError';
import Loading from '../Loading';
import TopNavigation from '../TopNavigation';
import { OnboardingShell, OnboardingFrame, OnboardingHeader, OnboardingPrimaryButton, OnboardingSecurityFooter } from '../onboarding-visual';
import CaptureLoading from './CaptureLoading';
import { hasBackendDocumentOcr, ocrServiceSignature, waitForDocumentOcr } from './backendDocumentOcr';
import * as faceDetection from '@tensorflow-models/face-detection';
import '@tensorflow/tfjs';
import { ButtonContainer, Camera, CameraContainer, CameraWrapper, Container, CustomImageButton, DocumentCaptureOverlay, DocumentLabel, DocumentLabelRotated, DocumentMargin, DocumentMarginContainer, DocumentSideContainer, DocumentSidesDivider, FramingHintContainer, FramingHintText, ImageStepContainer, StartButton, SwitchCameraButton, } from './styles';
pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.js';
import './styles.css';
import 'react-toastify/dist/ReactToastify.css';
import ImageUtils from '../../util/image-processing.util';
import Validations from '../../util/Validations';
import { RiUpload2Line, RiRefreshLine, RiBankCardLine } from 'react-icons/ri';
import { useTranslation } from '../../i18n';
import { getGuideBoxSourceRect } from '../../util/camera-frame.util';
import useLiveFramingFeedback, { preloadFramingScanner } from '../../util/useLiveFramingFeedback';
var fileFormats = {
    "image/png": "png",
    "image/jpg": "jpg",
    "image/jpeg": "jpeg",
    "application/pdf": "pdf",
};
var MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
var MAX_QUALITY_REJECTIONS = 2;
var LARGE_IMAGE_QUALITY = 0.8;
var SINGLE_IDENTIFICATION_DOCUMENT_ALIAS = 'single_identification_document';
var IDENTIFICATION_DOCUMENT_FRONT_ALIAS = 'identification_document_image_front';
var IDENTIFICATION_DOCUMENT_BACK_ALIAS = 'identification_document_image_back';
var OCR_VESTA_FIELD_ALIASES = ['cpf', 'name', 'birth_date'];
var CNPJ_LEGAL_DOCUMENT_FIELD_ALIASES = ['social_contract', 'statute'];
var mergeFieldsByAlias = function (originalFields, incomingFields) {
    var mergedFields = originalFields.map(function (field) { return (__assign({}, field)); });
    incomingFields.forEach(function (incomingField) {
        var existingIndex = mergedFields.findIndex(function (field) { return field.field === incomingField.field; });
        if (existingIndex >= 0) {
            mergedFields[existingIndex] = __assign(__assign({}, mergedFields[existingIndex]), incomingField);
        }
        else {
            mergedFields.push(__assign({}, incomingField));
        }
    });
    return mergedFields;
};
var loadModel = function (modelType) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, faceDetection.createDetector(faceDetection.SupportedModels.MediaPipeFaceDetector, {
                    runtime: 'mediapipe',
                    maxFaces: 1,
                    solutionPath: 'https://cdn.jsdelivr.net/npm/@mediapipe/face_detection',
                    modelType: modelType,
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
function detectFace(image, hasRotated) {
    if (hasRotated === void 0) { hasRotated = false; }
    return __awaiter(this, void 0, void 0, function () {
        var detector, faces, rotated, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 7]);
                    return [4 /*yield*/, loadModel('full')];
                case 1:
                    detector = _a.sent();
                    return [4 /*yield*/, detector.estimateFaces(image)];
                case 2:
                    faces = _a.sent();
                    if (!(faces.length === 0)) return [3 /*break*/, 5];
                    console.warn("Nenhum rosto detectado com 'full', tentando 'short'...");
                    return [4 /*yield*/, loadModel('short')];
                case 3:
                    detector = _a.sent();
                    return [4 /*yield*/, detector.estimateFaces(image)];
                case 4:
                    faces = _a.sent();
                    _a.label = 5;
                case 5:
                    if (faces.length === 0 && !hasRotated) {
                        console.warn("Nenhum rosto detectado. Girando 180 graus e tentando novamente...");
                        rotated = ImageUtils.rotateImage(image, 180);
                        return [2 /*return*/, detectFace(rotated, true)];
                    }
                    console.log("Faces detectadas:", faces);
                    return [2 /*return*/, {
                            isFaceDetected: faces.length > 0,
                            isPossibleFalsePositive: faces.length > 0 ? Validations.isFaceLikelyFalsePositive(faces[0]) : false,
                        }];
                case 6:
                    error_1 = _a.sent();
                    console.error("Erro durante a detecção de rosto:", error_1);
                    return [2 /*return*/, { isFaceDetected: false, isPossibleFalsePositive: false }];
                case 7: return [2 /*return*/];
            }
        });
    });
}
function detectRgDocument(img, rotateStep) {
    if (rotateStep === void 0) { rotateStep = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var worker, data, lines, validDocument, blacklistResidencial, isProvavelResidencial, angle, rotated;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createWorker('por', 1)];
                case 1:
                    worker = _a.sent();
                    return [4 /*yield*/, worker.setParameters({
                            tessedit_char_whitelist: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzáéíóúãõâêôÁÉÍÓÚÃÕÂÊÔçÇ ',
                            preserve_interword_spaces: '1',
                            tessedit_pageseg_mode: Tesseract.PSM.AUTO
                        })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, worker.recognize(img)];
                case 3:
                    data = (_a.sent()).data;
                    lines = data.text.toLowerCase().split('\n');
                    validDocument = lines.some(function (line) {
                        return line.includes('rg') ||
                            line.includes('registro geral') ||
                            line.includes('registro civil') ||
                            line.includes('rne') ||
                            line.includes('órgão emissor') ||
                            line.includes('todo o território nacional') ||
                            line.includes('folha') ||
                            line.includes('livro') ||
                            line.includes('identificação');
                    });
                    blacklistResidencial = ['água', 'energia', 'residencial', 'vencimento', 'volume medido', 'celular', 'saneamento', 'esgoto', 'caesb', 'enel', 'tarifa', 'fatura', 'valor a pagar', 'internet', 'limite', 'disponível'];
                    isProvavelResidencial = blacklistResidencial.some(function (p) {
                        return data.text.toLowerCase().includes(p);
                    });
                    return [4 /*yield*/, worker.terminate()];
                case 4:
                    _a.sent();
                    if (!validDocument && !isProvavelResidencial && rotateStep < 3) {
                        angle = (rotateStep + 1) * 90;
                        console.warn("Revalidando textos do documento. Girando ".concat(angle, " graus e tentando novamente..."));
                        rotated = ImageUtils.rotateImage(img, angle);
                        return [2 /*return*/, detectRgDocument(rotated, rotateStep + 1)];
                    }
                    return [2 /*return*/, (!isProvavelResidencial && validDocument)];
            }
        });
    });
}
function detectCnpjDocument(img, rotateStep) {
    if (rotateStep === void 0) { rotateStep = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var worker, data, cnpjKeywords, hasCnpjKeywords, cnpjPattern, hasCnpjPattern, businessTerms, hasBusinessTerms, isCnpjDocument, angle, rotated;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createWorker('por', 1)];
                case 1:
                    worker = _a.sent();
                    return [4 /*yield*/, worker.setParameters({
                            tessedit_char_whitelist: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzáéíóúãõâêôÁÉÍÓÚÃÕÂÊÔçÇ0123456789./-',
                            preserve_interword_spaces: '1',
                            tessedit_pageseg_mode: Tesseract.PSM.AUTO
                        })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, worker.recognize(img)];
                case 3:
                    data = (_a.sent()).data;
                    cnpjKeywords = [
                        'cnpj',
                        'cadastro nacional',
                        'pessoa jurídica',
                        'receita federal',
                        'comprovante de inscrição',
                        'cartão cnpj',
                        'situação cadastral',
                        'atividade econômica',
                        'razão social',
                        'nome empresarial',
                        'contrato social',
                        'alteração contratual',
                        'estatuto social',
                        'assembleia geral'
                    ];
                    hasCnpjKeywords = cnpjKeywords.some(function (keyword) {
                        return data.text.toLowerCase().includes(keyword);
                    });
                    cnpjPattern = /\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}/;
                    hasCnpjPattern = cnpjPattern.test(data.text);
                    businessTerms = [
                        'ltda',
                        'sociedade',
                        'empresa',
                        'microempresa',
                        'mei',
                        'eireli',
                        's.a.',
                        'matriz',
                        'filial'
                    ];
                    hasBusinessTerms = businessTerms.some(function (term) {
                        return data.text.toLowerCase().includes(term);
                    });
                    return [4 /*yield*/, worker.terminate()];
                case 4:
                    _a.sent();
                    isCnpjDocument = hasCnpjKeywords || hasCnpjPattern || hasBusinessTerms;
                    if (!isCnpjDocument && rotateStep < 3) {
                        angle = (rotateStep + 1) * 90;
                        console.warn("Revalidando documento CNPJ. Girando ".concat(angle, " graus e tentando novamente..."));
                        rotated = ImageUtils.rotateImage(img, angle);
                        return [2 /*return*/, detectCnpjDocument(rotated, rotateStep + 1)];
                    }
                    return [2 /*return*/, isCnpjDocument];
            }
        });
    });
}
var documentBorderWidth = 4;
var FRAMING_HINT_KEYS = {
    'no-document': 'camera.noDocumentDetected',
    shaky: 'camera.holdSteady',
    'move-closer': 'camera.moveCloser',
    'move-farther': 'camera.moveFarther',
    'move-left': 'camera.moveLeft',
    'move-right': 'camera.moveRight',
    'move-up': 'camera.moveUp',
    'move-down': 'camera.moveDown',
    adjust: 'camera.misalignedDocument',
    'well-framed': 'camera.wellFramedDocument',
};
function isFrontTierField(rawFieldName) {
    var fieldName = rawFieldName.toLowerCase();
    var isSinglePhotoDocument = fieldName.includes('cnh') || fieldName.includes('oab') || fieldName.includes(SINGLE_IDENTIFICATION_DOCUMENT_ALIAS);
    return fieldName.includes('front') || (isSinglePhotoDocument && !fieldName.includes('back'));
}
var StepImage = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var step = _a.step;
    var t = useTranslation().t;
    var _k = useSelector(function (state) { return state.form; }), form = _k.form, formInfo = _k.formInfo, progressForm = _k.progressForm;
    var theme = useSelector(function (state) { return state.theme; }).theme;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var isLandscape = useOrientation();
    var _l = useState(0), field = _l[0], setField = _l[1];
    var _m = useState(null), confirmedDocumentFields = _m[0], setConfirmedDocumentFields = _m[1];
    var savedDocumentRef = useRef(null);
    var ocrControllerRef = useRef(null);
    useEffect(function () { return function () { var _a; (_a = ocrControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort(); }; }, []);
    var documentSubmitInFlight = useRef(false);
    var autoSubmittedImage = useRef(null);
    var _o = useState(false), submissionFailed = _o[0], setSubmissionFailed = _o[1];
    var _p = useState(false), loading = _p[0], setLoading = _p[1];
    var _q = useState(null), image = _q[0], setImage = _q[1];
    var _r = useState(null), originalDocument = _r[0], setOriginalDocument = _r[1];
    var _s = useState(null), splitIdentificationDocument = _s[0], setSplitIdentificationDocument = _s[1];
    var _t = useState(null), deviceId = _t[0], setDeviceId = _t[1];
    var _u = useState([]), availableCameras = _u[0], setAvailableCameras = _u[1];
    var _v = useState(0), currentCameraIndex = _v[0], setCurrentCameraIndex = _v[1];
    var _w = useState(false), cameraLoaded = _w[0], setCameraLoaded = _w[1];
    var _x = useState(false), changingDocumentSide = _x[0], setChangingDocumentSide = _x[1];
    useEffect(function () {
        if (!changingDocumentSide || !cameraLoaded)
            return;
        var timeout = window.setTimeout(function () { return setChangingDocumentSide(false); }, 450);
        return function () { return window.clearTimeout(timeout); };
    }, [changingDocumentSide, cameraLoaded]);
    var _y = useState(null), foundCamera = _y[0], setFoundCamera = _y[1];
    var _z = useState(false), retryPermission = _z[0], setRetryPermission = _z[1];
    var _0 = useState(true), cameraPermission = _0[0], setCameraPermission = _0[1];
    var _1 = useState(0), cameraAttempt = _1[0], setCameraAttempt = _1[1];
    var _2 = useState(false), useBasicCameraConstraints = _2[0], setUseBasicCameraConstraints = _2[1];
    var _3 = useState(null), cameraFailure = _3[0], setCameraFailure = _3[1];
    var _4 = useState({ width: 0, height: 0 }), marginStyle = _4[0], setMarginStyle = _4[1];
    var documentCaptureFrameRef = useRef(null);
    var webcamRef = useRef(null);
    var getDocumentCaptureRect = function () {
        var _a;
        var frame = documentCaptureFrameRef.current;
        var video = (_a = webcamRef.current) === null || _a === void 0 ? void 0 : _a.video;
        if (!frame || !video || isLandscape)
            return undefined;
        var box = frame.getBoundingClientRect();
        var camera = video.getBoundingClientRect();
        return { left: box.left - camera.left + 1, top: box.top - camera.top + 1, width: box.width - 2, height: box.height - 2 };
    };
    var topNavigationRef = useRef(null);
    var currentStep = form.steps[step];
    useEffect(function () {
        preloadFramingScanner().catch(function () { });
    }, []);
    var mobileView = (isMobile || window.innerWidth === 390);
    var currentDocumentFieldName = (_c = (_b = currentStep.fields[field]) === null || _b === void 0 ? void 0 : _b.field.toLowerCase()) !== null && _c !== void 0 ? _c : '';
    var isSingleSubmission = currentDocumentFieldName.includes(SINGLE_IDENTIFICATION_DOCUMENT_ALIAS) ||
        currentDocumentFieldName.includes('cnh');
    var isTwoSidedDocument = currentStep.fields.length > 1;
    var qualityRejectionCountRef = useRef(0);
    var _5 = useState(null), liveGuideBox = _5[0], setLiveGuideBox = _5[1];
    useEffect(function () {
        if (!cameraLoaded) {
            setLiveGuideBox(null);
            return;
        }
        var computeGuideBox = function () {
            var _a;
            var video = (_a = webcamRef.current) === null || _a === void 0 ? void 0 : _a.video;
            if (!video || !video.videoWidth) {
                return false;
            }
            var _b = getGuideBoxSourceRect({
                cameraWidth: video.offsetWidth,
                cameraHeight: video.offsetHeight,
                naturalWidth: video.videoWidth,
                naturalHeight: video.videoHeight,
                marginWidth: marginStyle.width,
                marginHeight: marginStyle.height,
                isLandscape: isLandscape,
                documentBorderWidth: documentBorderWidth,
                guideRect: getDocumentCaptureRect(),
            }), sx = _b.sx, sy = _b.sy, sWidth = _b.sWidth, sHeight = _b.sHeight;
            setLiveGuideBox({ x: sx, y: sy, width: sWidth, height: sHeight });
            return true;
        };
        if (computeGuideBox()) {
            return;
        }
        var retryIntervalId = window.setInterval(function () {
            if (computeGuideBox()) {
                window.clearInterval(retryIntervalId);
            }
        }, 100);
        return function () {
            window.clearInterval(retryIntervalId);
        };
    }, [cameraLoaded, marginStyle, isLandscape, deviceId, isSingleSubmission]);
    var framingState = useLiveFramingFeedback({
        videoElement: (_e = (_d = webcamRef.current) === null || _d === void 0 ? void 0 : _d.video) !== null && _e !== void 0 ? _e : null,
        guideBox: liveGuideBox,
        enabled: !image && cameraLoaded,
    });
    var framingHintKey = FRAMING_HINT_KEYS[framingState];
    var evaluateImageQuality = function (imageData, isFrontValue, resolutionWidth, resolutionHeight) {
        if (ImageUtils.isResolutionTooLow(resolutionWidth, resolutionHeight, isFrontValue)) {
            return t('camera.lowResolutionImage');
        }
        if (ImageUtils.isImageBlurry(imageData, isFrontValue)) {
            return t('camera.blurryImage');
        }
        return null;
    };
    var shouldRejectForQuality = function (imageData, isFrontValue, resolutionWidth, resolutionHeight) {
        if (resolutionWidth === void 0) { resolutionWidth = imageData.width; }
        if (resolutionHeight === void 0) { resolutionHeight = imageData.height; }
        var qualityError = evaluateImageQuality(imageData, isFrontValue, resolutionWidth, resolutionHeight);
        if (!qualityError) {
            qualityRejectionCountRef.current = 0;
            return false;
        }
        qualityRejectionCountRef.current += 1;
        if (qualityRejectionCountRef.current > MAX_QUALITY_REJECTIONS) {
            qualityRejectionCountRef.current = 0;
            toast.warn(t('camera.acceptingLowQuality'), {
                position: "top-center",
                autoClose: 4000,
            });
            return false;
        }
        showError(qualityError);
        return true;
    };
    var tryNextCamera = function (wrap) {
        if (wrap === void 0) { wrap = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var nextIndex;
            return __generator(this, function (_a) {
                if (availableCameras.length > 1 && (wrap || currentCameraIndex < availableCameras.length - 1)) {
                    nextIndex = (currentCameraIndex + 1) % availableCameras.length;
                    setCurrentCameraIndex(nextIndex);
                    setDeviceId(availableCameras[nextIndex].deviceId);
                    return [2 /*return*/, true];
                }
                return [2 /*return*/, false];
            });
        });
    };
    var capture = function () { return __awaiter(void 0, void 0, void 0, function () {
        var guideRect, orig_src_1, cameraWidth_1, cameraHeight_1, imageSrc, canvas_1, cnv_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            if (changingDocumentSide || !cameraLoaded || loading)
                return [2 /*return*/];
            guideRect = getDocumentCaptureRect();
            setLoading(true);
            if (webcamRef && webcamRef.current) {
                orig_src_1 = new Image();
                cameraWidth_1 = ((_b = (_a = webcamRef.current) === null || _a === void 0 ? void 0 : _a.video) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;
                cameraHeight_1 = ((_d = (_c = webcamRef.current) === null || _c === void 0 ? void 0 : _c.video) === null || _d === void 0 ? void 0 : _d.offsetHeight) || 0;
                imageSrc = webcamRef.current.getScreenshot();
                canvas_1 = document.createElement('canvas');
                cnv_1 = canvas_1.getContext('2d');
                if (!imageSrc) {
                    showError(t('camera.takingImageError'));
                    return [2 /*return*/];
                }
                if (!cnv_1) {
                    showError(t('errors.generic'));
                    return [2 /*return*/];
                }
                orig_src_1.src = imageSrc;
                orig_src_1.onload = function () {
                    var _a, _b, _c;
                    return __awaiter(this, void 0, void 0, function () {
                        var isFront, _d, sx, sy, sWidth, sHeight, capturedImageData, croppedImage_1, image_1;
                        var _this = this;
                        return __generator(this, function (_e) {
                            canvas_1.width = orig_src_1.naturalWidth;
                            canvas_1.height = orig_src_1.naturalHeight;
                            cnv_1.drawImage(orig_src_1, 0, 0);
                            isFront = isFrontTierField((_c = (_b = (_a = form.steps[step]) === null || _a === void 0 ? void 0 : _a.fields[field]) === null || _b === void 0 ? void 0 : _b.field) !== null && _c !== void 0 ? _c : '');
                            _d = getGuideBoxSourceRect({
                                cameraWidth: cameraWidth_1,
                                cameraHeight: cameraHeight_1,
                                naturalWidth: orig_src_1.naturalWidth,
                                naturalHeight: orig_src_1.naturalHeight,
                                marginWidth: marginStyle.width,
                                marginHeight: marginStyle.height,
                                isLandscape: isLandscape,
                                documentBorderWidth: documentBorderWidth,
                                guideRect: guideRect,
                            }), sx = _d.sx, sy = _d.sy, sWidth = _d.sWidth, sHeight = _d.sHeight;
                            canvas_1.width = sWidth;
                            canvas_1.height = sHeight;
                            try {
                                cnv_1.drawImage(orig_src_1, sx, sy, sWidth, sHeight, 0, 0, sWidth, sHeight);
                                capturedImageData = cnv_1.getImageData(0, 0, sWidth, sHeight);
                                if (shouldRejectForQuality(capturedImageData, isFront, orig_src_1.naturalWidth, orig_src_1.naturalHeight)) {
                                    return [2 /*return*/];
                                }
                                croppedImage_1 = canvas_1.toDataURL("image/png").toString();
                                image_1 = new Image();
                                image_1.src = croppedImage_1;
                                image_1.onload = function () { return __awaiter(_this, void 0, void 0, function () {
                                    var faceDetected, fieldValue, rotate_src_1, rotate_canvas_1, rotate_context_1, isCnpj;
                                    var _a, _b;
                                    return __generator(this, function (_c) {
                                        switch (_c.label) {
                                            case 0: return [4 /*yield*/, detectFace(image_1)];
                                            case 1:
                                                faceDetected = _c.sent();
                                                fieldValue = (_b = (_a = form.steps[step]) === null || _a === void 0 ? void 0 : _a.fields[field]) === null || _b === void 0 ? void 0 : _b.field;
                                                if (!(fieldValue && (fieldValue.includes('rg') || fieldValue.includes('rne')))) return [3 /*break*/, 2];
                                                if (isFront && !faceDetected.isFaceDetected) {
                                                    showError(t('camera.chooseDocumentFront'));
                                                    return [2 /*return*/];
                                                }
                                                if (!isFront && faceDetected.isFaceDetected) {
                                                    if (!faceDetected.isPossibleFalsePositive) {
                                                        showError(t('camera.chooseDocumentBack'));
                                                        return [2 /*return*/];
                                                    }
                                                }
                                                rotate_src_1 = new Image();
                                                rotate_canvas_1 = document.createElement("canvas");
                                                rotate_context_1 = rotate_canvas_1.getContext("2d");
                                                rotate_src_1.src = croppedImage_1;
                                                rotate_src_1.onload = function () {
                                                    rotate_canvas_1.width = rotate_src_1.height;
                                                    rotate_canvas_1.height = rotate_src_1.width;
                                                    if (rotate_context_1) {
                                                        rotate_context_1.clearRect(0, 0, rotate_canvas_1.width, rotate_canvas_1.height);
                                                        rotate_context_1.save();
                                                        rotate_context_1.translate(rotate_canvas_1.width / 2, rotate_canvas_1.height / 2);
                                                        rotate_context_1.rotate(270 * Math.PI / 180);
                                                        rotate_context_1.drawImage(rotate_src_1, -rotate_src_1.width / 2, -rotate_src_1.height / 2);
                                                        rotate_context_1.restore();
                                                        var rotatedImage = rotate_canvas_1.toDataURL("image/jpeg").toString();
                                                        setImage(rotatedImage);
                                                    }
                                                };
                                                return [3 /*break*/, 4];
                                            case 2:
                                                if (!['cnpj_card', 'social_contract', 'statute'].some(function (alias) { var _a, _b; return (_b = (_a = form.steps[step]) === null || _a === void 0 ? void 0 : _a.fields[field]) === null || _b === void 0 ? void 0 : _b.field.includes(alias); })) return [3 /*break*/, 4];
                                                return [4 /*yield*/, detectCnpjDocument(image_1)];
                                            case 3:
                                                isCnpj = _c.sent();
                                                if (!isCnpj) {
                                                    showError(t('camera.invalidCnpjDocument'));
                                                    return [2 /*return*/];
                                                }
                                                _c.label = 4;
                                            case 4:
                                                setImage(croppedImage_1);
                                                return [2 /*return*/];
                                        }
                                    });
                                }); };
                            }
                            catch (err) {
                                console.error('Err(2): ', err);
                                showError(t('camera.lowImageQuality'));
                            }
                            finally {
                                setLoading(false);
                            }
                            return [2 /*return*/];
                        });
                    });
                };
            }
            else {
                showError(t('camera.loadError'));
            }
            return [2 /*return*/];
        });
    }); };
    var showError = function (message) {
        toast.error(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
        });
        setLoading(false);
    };
    var clearPhoto = function () {
        qualityRejectionCountRef.current = 0;
        setImage(null);
        setOriginalDocument(null);
        setSplitIdentificationDocument(null);
    };
    var sendPhoto = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fields, controller, token, useBackendOcr, baselineResult, _a, response, saved, result, _1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!image || loading || documentSubmitInFlight.current)
                        return [2 /*return*/];
                    fields = currentStep.fields.map(function (item) { return (__assign({}, ((confirmedDocumentFields === null || confirmedDocumentFields === void 0 ? void 0 : confirmedDocumentFields.find(function (confirmed) { return confirmed.field === item.field; })) || item))); });
                    if (splitIdentificationDocument) {
                        fields.splice(field, 1, __assign(__assign({}, currentStep.fields[field]), { field: IDENTIFICATION_DOCUMENT_FRONT_ALIAS, label: 'Frente do documento', value: splitIdentificationDocument.front }), __assign(__assign({}, currentStep.fields[field]), { field: IDENTIFICATION_DOCUMENT_BACK_ALIAS, label: 'Verso do documento', value: splitIdentificationDocument.back }));
                    }
                    else {
                        fields[field] = __assign(__assign({}, fields[field]), { value: originalDocument || image });
                    }
                    setConfirmedDocumentFields(fields);
                    if (field + 1 < currentStep.fields.length) {
                        setChangingDocumentSide(true);
                        setCameraLoaded(false);
                        qualityRejectionCountRef.current = 0;
                        setField(field + 1);
                        setImage(null);
                        setOriginalDocument(null);
                        setSplitIdentificationDocument(null);
                        return [2 /*return*/];
                    }
                    setSubmissionFailed(false);
                    documentSubmitInFlight.current = true;
                    setLoading(true);
                    controller = new AbortController();
                    ocrControllerRef.current = controller;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 8, 9, 10]);
                    token = (formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding) || '';
                    useBackendOcr = hasBackendDocumentOcr(currentStep);
                    if (!!savedDocumentRef.current) return [3 /*break*/, 6];
                    if (!useBackendOcr) return [3 /*break*/, 3];
                    return [4 /*yield*/, Service.getStepResult({ tokenOnboarding: token, signal: controller.signal })];
                case 2:
                    _a = _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _c.label = 4;
                case 4:
                    baselineResult = _a;
                    if (controller.signal.aborted)
                        return [2 /*return*/];
                    return [4 /*yield*/, Service.saveStep({
                            onboardingForm: { countSteps: form.countSteps, steps: [__assign(__assign({}, currentStep), { fields: fields })] },
                            tokenOnboarding: token,
                        })];
                case 5:
                    response = _c.sent();
                    if (!((_b = response === null || response === void 0 ? void 0 : response.steps) === null || _b === void 0 ? void 0 : _b[0]))
                        throw new Error('Missing next step');
                    savedDocumentRef.current = { response: response, fields: fields, baseline: new Set(((baselineResult === null || baselineResult === void 0 ? void 0 : baselineResult.services) || []).map(ocrServiceSignature)) };
                    _c.label = 6;
                case 6:
                    if (controller.signal.aborted)
                        return [2 /*return*/];
                    if (!useBackendOcr) {
                        continueAfterDocumentReview();
                        return [2 /*return*/];
                    }
                    saved = savedDocumentRef.current;
                    return [4 /*yield*/, waitForDocumentOcr(token, saved.baseline, controller.signal, Service.getStepResult)];
                case 7:
                    result = _c.sent();
                    if (controller.signal.aborted)
                        return [2 /*return*/];
                    dispatch(FormActions.setDocumentDataReview({
                        sourceStep: currentStep.step,
                        documents: saved.fields.filter(function (item) { return item.value && /^data:(image|application\/pdf)/.test(item.value); })
                            .map(function (item) { return ({ label: item.label, value: item.value }); }),
                        values: result.approved ? Object.fromEntries(result.fields.map(function (item) { return [item.field.toLowerCase(), item.value]; })) : {},
                    }));
                    continueAfterDocumentReview();
                    return [3 /*break*/, 10];
                case 8:
                    _1 = _c.sent();
                    if (!controller.signal.aborted) {
                        setSubmissionFailed(true);
                        toast.error(t('image.reviewBackendError'));
                    }
                    return [3 /*break*/, 10];
                case 9:
                    if (ocrControllerRef.current === controller) {
                        ocrControllerRef.current = null;
                        documentSubmitInFlight.current = false;
                        setLoading(false);
                    }
                    return [7 /*endfinally*/];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var continueAfterDocumentReview = function () {
        var saved = savedDocumentRef.current;
        if (!saved)
            return;
        dispatch(FormActions.addFormStep(saved.response));
        navigate('/form', { state: { step: saved.response.steps[0].step } });
        savedDocumentRef.current = null;
        setConfirmedDocumentFields(null);
        clearPhoto();
        setField(0);
    };
    var handleCamera = function () {
        var _a;
        setCameraFailure(null);
        try {
            // First stop any existing streams
            stopAllTracks();
            // Request the default rear camera first. Device IDs and permission
            // queries are not reliable prerequisites for capture on Safari.
            if (!((_a = navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.getUserMedia)) {
                throw new Error(t('camera.unavailable'));
            }
            setCameraLoaded(false);
            setDeviceId(null);
            setCameraPermission(true);
            setFoundCamera(true);
            setCameraAttempt(function (attempt) { return attempt + 1; });
            setAvailableCameras([]);
            setCurrentCameraIndex(0);
        }
        catch (error) {
            var errorMessage = error instanceof Error ? error.message : 'unknown error';
            console.error("Error handling camera:", error);
            toast.error(t('camera.accessError', { message: errorMessage }));
            setCameraFailure(errorMessage);
            window.alert("".concat(t('camera.failureTitle'), "\n").concat(errorMessage));
            setFoundCamera(false);
            setCameraPermission(false);
        }
    };
    var stopAllTracks = function () {
        var _a;
        try {
            // Stop tracks from webcam ref
            if ((_a = webcamRef.current) === null || _a === void 0 ? void 0 : _a.stream) {
                webcamRef.current.stream.getTracks().forEach(function (track) {
                    track.stop();
                });
                webcamRef.current.stream = null;
            }
        }
        catch (error) {
            console.warn('Error stopping tracks:', error);
        }
    };
    var convertToBase64 = function (file) {
        return new Promise(function (resolve, reject) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function () {
                if (typeof fileReader.result === 'string') {
                    resolve(fileReader.result);
                }
                else {
                    reject(new Error('File reading failed'));
                }
            };
            fileReader.onerror = function (error) {
                reject(error);
            };
        });
    };
    var getImageDimensions = function (base64) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve({ width: img.naturalWidth, height: img.naturalHeight }); };
            img.onerror = function () { return reject(new Error('Failed to read image dimensions')); };
            img.src = base64;
        });
    };
    var getBase64SizeBytes = function (dataUrl) {
        var commaIndex = dataUrl.indexOf(',');
        var base64String = commaIndex >= 0 ? dataUrl.slice(commaIndex + 1) : dataUrl;
        var paddingMatch = base64String.match(/=+$/);
        var padding = paddingMatch ? paddingMatch[0].length : 0;
        return Math.floor((base64String.length * 3) / 4) - padding;
    };
    var handleFile = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var fileInput, file, isLargeFile, base64_1, originalDimensions_1, img_1, error_2;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    fileInput = e.target;
                    file = (_a = fileInput.files) === null || _a === void 0 ? void 0 : _a[0];
                    toast.dismiss();
                    fileInput.value = '';
                    if (file && !((_c = (_b = form.steps[step]) === null || _b === void 0 ? void 0 : _b.fields[field].uploads) === null || _c === void 0 ? void 0 : _c.includes(fileFormats[file.type]))) {
                        toast.error(t('camera.invalidFormat'), {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                        });
                        return [2 /*return*/];
                    }
                    if (!file) return [3 /*break*/, 11];
                    setLoading(true);
                    setSplitIdentificationDocument(null);
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 9, 10, 11]);
                    isLargeFile = file.size > MAX_FILE_SIZE_BYTES;
                    return [4 /*yield*/, convertToBase64(file)];
                case 2:
                    base64_1 = _f.sent();
                    originalDimensions_1 = null;
                    if (!(file.type === "application/pdf")) return [3 /*break*/, 7];
                    if (!((_e = (_d = form.steps[step]) === null || _d === void 0 ? void 0 : _d.fields[field]) === null || _e === void 0 ? void 0 : _e.field.includes("rg"))) return [3 /*break*/, 4];
                    return [4 /*yield*/, convertRgPdfToImages(base64_1, isLargeFile)];
                case 3:
                    _f.sent();
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, convertPdfToImages(base64_1, isLargeFile)];
                case 5:
                    _f.sent();
                    _f.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    if (typeof base64_1 === "string") {
                        if (getBase64SizeBytes(base64_1) > MAX_FILE_SIZE_BYTES) {
                            showError(t('camera.fileTooLarge'));
                            return [2 /*return*/];
                        }
                        img_1 = new Image();
                        img_1.src = base64_1;
                        img_1.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                            var faceDetected, isFront, canvas, cnv, uploadedImageData, isFrontUpload, resolutionWidth, resolutionHeight;
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                            return __generator(this, function (_m) {
                                switch (_m.label) {
                                    case 0: return [4 /*yield*/, detectFace(img_1)];
                                    case 1:
                                        faceDetected = _m.sent();
                                        if (((_b = (_a = form.steps[step]) === null || _a === void 0 ? void 0 : _a.fields[field]) === null || _b === void 0 ? void 0 : _b.field.includes("rg")) ||
                                            ((_d = (_c = form.steps[step]) === null || _c === void 0 ? void 0 : _c.fields[field]) === null || _d === void 0 ? void 0 : _d.field.includes("rne"))) {
                                            isFront = (_f = (_e = form.steps[step]) === null || _e === void 0 ? void 0 : _e.fields[field]) === null || _f === void 0 ? void 0 : _f.field.includes("front");
                                            if (isFront && !faceDetected.isFaceDetected) {
                                                showError(t('camera.chooseDocumentFront'));
                                                return [2 /*return*/];
                                            }
                                            if (!isFront && faceDetected.isFaceDetected) {
                                                if (!faceDetected.isPossibleFalsePositive) {
                                                    showError(t('camera.chooseDocumentBack'));
                                                    return [2 /*return*/];
                                                }
                                            }
                                            // } else if (form.steps[step]?.fields[field]?.field.includes("address")) {
                                            //   if (faceDetected) {
                                            //     showError("Documento inválido como comprovante de endereço!");
                                            //     return;
                                            //   }
                                            //   const invalidDocument = await detectRgDocument(img);
                                            //   if (invalidDocument) {
                                            //     showError("Documento inválido como comprovante de endereço!");
                                            //     return;
                                            //   }
                                        }
                                        canvas = document.createElement("canvas");
                                        cnv = canvas.getContext("2d");
                                        canvas.width = img_1.naturalWidth;
                                        canvas.height = img_1.naturalHeight;
                                        if (cnv) {
                                            cnv.drawImage(img_1, 0, 0);
                                            uploadedImageData = cnv.getImageData(0, 0, canvas.width, canvas.height);
                                            isFrontUpload = isFrontTierField((_j = (_h = (_g = form.steps[step]) === null || _g === void 0 ? void 0 : _g.fields[field]) === null || _h === void 0 ? void 0 : _h.field) !== null && _j !== void 0 ? _j : '');
                                            resolutionWidth = (_k = originalDimensions_1 === null || originalDimensions_1 === void 0 ? void 0 : originalDimensions_1.width) !== null && _k !== void 0 ? _k : canvas.width;
                                            resolutionHeight = (_l = originalDimensions_1 === null || originalDimensions_1 === void 0 ? void 0 : originalDimensions_1.height) !== null && _l !== void 0 ? _l : canvas.height;
                                            if (shouldRejectForQuality(uploadedImageData, isFrontUpload, resolutionWidth, resolutionHeight)) {
                                                return [2 /*return*/];
                                            }
                                        }
                                        setImage(base64_1);
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                    }
                    _f.label = 8;
                case 8: return [3 /*break*/, 11];
                case 9:
                    error_2 = _f.sent();
                    console.error(error_2);
                    return [3 /*break*/, 11];
                case 10:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var convertRgPdfToImages = function (data, compress) {
        if (compress === void 0) { compress = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var pdf, _loop_1, pageNum, state_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, pdfjs.getDocument(data).promise];
                    case 1:
                        pdf = _a.sent();
                        if (pdf.numPages > 2) {
                            showError(t('camera.pdfMaxTwoPages'));
                            return [2 /*return*/];
                        }
                        _loop_1 = function (pageNum) {
                            var page, canvas, viewport, context, base64Image, img;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, pdf.getPage(pageNum)];
                                    case 1:
                                        page = _b.sent();
                                        canvas = document.createElement("canvas");
                                        viewport = page.getViewport({ scale: compress ? 1.5 : 2 });
                                        context = canvas.getContext("2d");
                                        canvas.height = viewport.height;
                                        canvas.width = viewport.width;
                                        return [4 /*yield*/, page.render({ canvasContext: context, viewport: viewport }).promise];
                                    case 2:
                                        _b.sent();
                                        base64Image = compress ? canvas.toDataURL("image/jpeg", LARGE_IMAGE_QUALITY) : canvas.toDataURL();
                                        if (getBase64SizeBytes(base64Image) > MAX_FILE_SIZE_BYTES) {
                                            canvas.remove();
                                            showError(t('camera.fileTooLarge'));
                                            return [2 /*return*/, { value: void 0 }];
                                        }
                                        img = new Image();
                                        img.src = base64Image;
                                        img.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                                            var isFront, faceDetected;
                                            var _a, _b;
                                            return __generator(this, function (_c) {
                                                switch (_c.label) {
                                                    case 0:
                                                        isFront = (_b = (_a = form.steps[step]) === null || _a === void 0 ? void 0 : _a.fields[field]) === null || _b === void 0 ? void 0 : _b.field.includes('front');
                                                        return [4 /*yield*/, detectFace(img)];
                                                    case 1:
                                                        faceDetected = _c.sent();
                                                        if (isFront && !faceDetected.isFaceDetected) {
                                                            showError(t('camera.chooseDocumentFront'));
                                                            return [2 /*return*/];
                                                        }
                                                        if (!isFront && faceDetected.isFaceDetected) {
                                                            if (!faceDetected.isPossibleFalsePositive) {
                                                                showError(t('camera.chooseDocumentBack'));
                                                                return [2 /*return*/];
                                                            }
                                                        }
                                                        setImage(base64Image);
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); };
                                        img.onerror = function (error) {
                                            console.error("Erro ao carregar a imagem da p\u00E1gina ".concat(pageNum, ":"), error);
                                        };
                                        canvas.remove();
                                        return [2 /*return*/];
                                }
                            });
                        };
                        pageNum = 1;
                        _a.label = 2;
                    case 2:
                        if (!(pageNum <= pdf.numPages)) return [3 /*break*/, 5];
                        return [5 /*yield**/, _loop_1(pageNum)];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object")
                            return [2 /*return*/, state_1.value];
                        _a.label = 4;
                    case 4:
                        pageNum++;
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_1 = _a.sent();
                        console.error("Erro ao processar o PDF:", err_1);
                        showError(t('errors.pdfError'));
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    var convertPdfToImages = function (data, compress) {
        if (compress === void 0) { compress = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var pdf, isSingleIdentificationDocument, renderedPages, pageNumber, page_1, canvas_2, viewport_1, context_1, renderedPage, splitDocument, isCnpjLegalDocument, canvas, page, viewport, context, base64Image_1, resizedImage, newBase64, img, img, canvas_3, cnv, isFront, worker, recognizedText, i, canvas_4, context_2, imageUrl, response, blob, text, error_3, err_2;
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        _j.trys.push([0, 26, , 27]);
                        return [4 /*yield*/, pdfjs.getDocument(data).promise];
                    case 1:
                        pdf = _j.sent();
                        isSingleIdentificationDocument = (_b = (_a = form.steps[step]) === null || _a === void 0 ? void 0 : _a.fields[field]) === null || _b === void 0 ? void 0 : _b.field.toLowerCase().includes(SINGLE_IDENTIFICATION_DOCUMENT_ALIAS);
                        if (!(isSingleIdentificationDocument && pdf.numPages === 2)) return [3 /*break*/, 7];
                        renderedPages = [];
                        pageNumber = 1;
                        _j.label = 2;
                    case 2:
                        if (!(pageNumber <= 2)) return [3 /*break*/, 6];
                        return [4 /*yield*/, pdf.getPage(pageNumber)];
                    case 3:
                        page_1 = _j.sent();
                        canvas_2 = document.createElement('canvas');
                        viewport_1 = page_1.getViewport({ scale: compress ? 2 : 3 });
                        context_1 = canvas_2.getContext('2d');
                        if (!context_1) {
                            throw new Error('Não foi possível processar uma página do PDF.');
                        }
                        canvas_2.height = viewport_1.height;
                        canvas_2.width = viewport_1.width;
                        return [4 /*yield*/, page_1.render({ canvasContext: context_1, viewport: viewport_1 }).promise];
                    case 4:
                        _j.sent();
                        renderedPage = compress
                            ? canvas_2.toDataURL('image/jpeg', LARGE_IMAGE_QUALITY)
                            : canvas_2.toDataURL();
                        canvas_2.remove();
                        if (getBase64SizeBytes(renderedPage) > MAX_FILE_SIZE_BYTES) {
                            showError(t('camera.fileTooLarge'));
                            return [2 /*return*/];
                        }
                        renderedPages.push(renderedPage);
                        _j.label = 5;
                    case 5:
                        pageNumber++;
                        return [3 /*break*/, 2];
                    case 6:
                        splitDocument = {
                            front: renderedPages[0],
                            back: renderedPages[1],
                        };
                        setSplitIdentificationDocument(splitDocument);
                        setImage(splitDocument.front);
                        return [2 /*return*/];
                    case 7:
                        isCnpjLegalDocument = CNPJ_LEGAL_DOCUMENT_FIELD_ALIASES.some(function (alias) { var _a, _b; return (_b = (_a = form.steps[step]) === null || _a === void 0 ? void 0 : _a.fields[field]) === null || _b === void 0 ? void 0 : _b.field.includes(alias); });
                        if (isCnpjLegalDocument && pdf.numPages > 30) {
                            showError(t('camera.pdfMaxThirtyPages'));
                            return [2 /*return*/];
                        }
                        canvas = document.createElement("canvas");
                        return [4 /*yield*/, pdf.getPage(1)];
                    case 8:
                        page = _j.sent();
                        viewport = page.getViewport({ scale: compress ? 2 : 3 });
                        context = canvas.getContext("2d");
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;
                        return [4 /*yield*/, page.render({ canvasContext: context, viewport: viewport }).promise];
                    case 9:
                        _j.sent();
                        base64Image_1 = compress ? canvas.toDataURL("image/jpeg", LARGE_IMAGE_QUALITY) : canvas.toDataURL();
                        if (getBase64SizeBytes(base64Image_1) > MAX_FILE_SIZE_BYTES) {
                            canvas.remove();
                            showError(t('camera.fileTooLarge'));
                            return [2 /*return*/];
                        }
                        resizedImage = ImageUtils.resizeImage(base64Image_1, 1000, 1000);
                        return [4 /*yield*/, resizedImage];
                    case 10:
                        newBase64 = _j.sent();
                        if (isCnpjLegalDocument) {
                            setOriginalDocument(data);
                            setImage(base64Image_1);
                            canvas.remove();
                            return [2 /*return*/];
                        }
                        if (!((_c = form.steps[step]) === null || _c === void 0 ? void 0 : _c.fields[field].field.includes("cnh"))) return [3 /*break*/, 11];
                        cropPDF(base64Image_1);
                        return [3 /*break*/, 25];
                    case 11:
                        if (!((_e = (_d = form.steps[step]) === null || _d === void 0 ? void 0 : _d.fields[field]) === null || _e === void 0 ? void 0 : _e.field.includes("address"))) return [3 /*break*/, 12];
                        img = new Image();
                        img.src = newBase64;
                        img.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                // const faceDetected = await detectFace(img);
                                // if (faceDetected) {
                                //   showError("Documento inválido como comprovante de endereço!");
                                //   return;
                                // }
                                // const invalidDocument = await detectRgDocument(img);
                                // if (invalidDocument) {
                                //   showError("Documento inválido como comprovante de endereço!");
                                //   return;
                                // }
                                setImage(base64Image_1);
                                return [2 /*return*/];
                            });
                        }); };
                        return [3 /*break*/, 25];
                    case 12: return [4 /*yield*/, new Promise(function (resolve, reject) {
                            var img = new Image();
                            img.src = base64Image_1;
                            img.onload = function () { return resolve(); };
                            img.onerror = function () { return reject(new Error("Erro ao carregar a imagem")); };
                        })];
                    case 13:
                        _j.sent();
                        img = new Image();
                        img.src = base64Image_1;
                        canvas_3 = document.createElement("canvas");
                        cnv = canvas_3.getContext("2d");
                        canvas_3.width = img.naturalWidth;
                        canvas_3.height = img.naturalHeight;
                        if (cnv)
                            cnv.drawImage(img, 0, 0);
                        isFront = isFrontTierField((_h = (_g = (_f = form.steps[step]) === null || _f === void 0 ? void 0 : _f.fields[field]) === null || _g === void 0 ? void 0 : _g.field) !== null && _h !== void 0 ? _h : '');
                        return [4 /*yield*/, createWorker("por")];
                    case 14:
                        worker = _j.sent();
                        return [4 /*yield*/, worker.setParameters({
                                tessedit_char_whitelist: "0123456789",
                            })];
                    case 15:
                        _j.sent();
                        recognizedText = "";
                        i = 0;
                        _j.label = 16;
                    case 16:
                        if (!(i < 4)) return [3 /*break*/, 23];
                        canvas_4 = document.createElement("canvas");
                        context_2 = canvas_4.getContext("2d");
                        canvas_4.width = i % 2 === 0 ? img.width : img.height;
                        canvas_4.height = i % 2 === 0 ? img.height : img.width;
                        if (!context_2) return [3 /*break*/, 22];
                        _j.label = 17;
                    case 17:
                        _j.trys.push([17, 21, , 22]);
                        context_2.translate(canvas_4.width / 2, canvas_4.height / 2);
                        context_2.rotate(i * Math.PI / 2);
                        context_2.drawImage(img, -img.width / 2, -img.height / 2);
                        imageUrl = canvas_4.toDataURL("image/png");
                        return [4 /*yield*/, fetch(imageUrl)];
                    case 18:
                        response = _j.sent();
                        return [4 /*yield*/, response.blob()];
                    case 19:
                        blob = _j.sent();
                        return [4 /*yield*/, worker.recognize(blob)];
                    case 20:
                        text = (_j.sent()).data.text;
                        if (isFront) {
                            if (text.trim() !== "" && text.length >= 5) {
                                recognizedText = text;
                                return [3 /*break*/, 23];
                            }
                        }
                        else {
                            if (text.replace(/\D/g, "").length >= 11) {
                                recognizedText = text;
                                return [3 /*break*/, 23];
                            }
                        }
                        return [3 /*break*/, 22];
                    case 21:
                        error_3 = _j.sent();
                        console.log(error_3);
                        return [3 /*break*/, 22];
                    case 22:
                        i++;
                        return [3 /*break*/, 16];
                    case 23: return [4 /*yield*/, worker.terminate()];
                    case 24:
                        _j.sent();
                        if (!recognizedText) {
                            toast.error(t('camera.lowQuality'), {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: false,
                                draggable: true,
                            });
                            setImage(null);
                            return [2 /*return*/];
                        }
                        setImage(base64Image_1);
                        _j.label = 25;
                    case 25:
                        canvas.remove();
                        return [3 /*break*/, 27];
                    case 26:
                        err_2 = _j.sent();
                        if ((err_2 === null || err_2 === void 0 ? void 0 : err_2.message) && typeof err_2.message === "string" && err_2.message.includes("No password given")) {
                            showError(t('camera.lockFile'));
                            return [2 /*return*/];
                        }
                        showError(t('errors.pdfError'));
                        return [3 /*break*/, 27];
                    case 27: return [2 /*return*/];
                }
            });
        });
    };
    var cropPDF = function (pdfImage) {
        var canvas = document.createElement('canvas');
        var cnv = canvas.getContext('2d');
        var orig_src = new Image();
        if (pdfImage)
            orig_src.src = pdfImage;
        orig_src.onload = function () {
            canvas.width = orig_src.naturalWidth / 2;
            canvas.height = orig_src.naturalHeight / 2;
            var sx = 0;
            var sy = 0;
            var sWidth = canvas.width;
            var sHeight = canvas.height;
            var dx = 0;
            var dy = 0;
            var dWidth = sWidth;
            var dHeight = sHeight;
            if (cnv) {
                cnv.drawImage(orig_src, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
                var croppedImage = canvas.toDataURL("image/png").toString();
                setImage(croppedImage);
            }
        };
    };
    var isDocumentCameraActive = function () { return (foundCamera === true &&
        cameraPermission &&
        !retryPermission &&
        !image); };
    var renderDocumentCaptureOverlay = function () {
        var _a, _b;
        if (!isDocumentCameraActive()) {
            return null;
        }
        var currentField = (_a = form.steps[step]) === null || _a === void 0 ? void 0 : _a.fields[field];
        var currentFieldName = (_b = currentField === null || currentField === void 0 ? void 0 : currentField.field.toLowerCase()) !== null && _b !== void 0 ? _b : '';
        var documentName = isSingleSubmission
            ? t('image.captureSingleTitle')
            : (currentField === null || currentField === void 0 ? void 0 : currentField.label) || (currentField === null || currentField === void 0 ? void 0 : currentField.field) || t('image.document');
        var hasDocumentSide = isTwoSidedDocument ||
            currentFieldName.includes('front') ||
            currentFieldName.includes('back') ||
            currentFieldName.includes(SINGLE_IDENTIFICATION_DOCUMENT_ALIAS) ||
            currentFieldName.includes('cnh') ||
            currentFieldName.includes('oab');
        var labelAlreadyIncludesSide = /\b(frente|verso|front|back)\b/i.test(documentName);
        var documentSide = !isSingleSubmission && hasDocumentSide && !labelAlreadyIncludesSide
            ? isFrontTierField(currentFieldName) ? t('image.front') : t('image.back')
            : '';
        return (React.createElement(DocumentCaptureOverlay, { "aria-busy": loading || !cameraLoaded, "data-capture-mode": isSingleSubmission ? 'single' : 'two-sided' },
            React.createElement("header", { className: "document-capture-header" },
                React.createElement("div", { className: "document-capture-header-nav" },
                    React.createElement(TopNavigation, { showLogo: false, showBackButton: currentStep.goBack, headerTransparent: true, headerPadding: 0 })),
                React.createElement("div", { className: "document-capture-heading" },
                    React.createElement("p", { className: "document-capture-eyebrow" }, t('image.captureHeader')),
                    React.createElement("p", { className: "document-capture-title" },
                        documentName,
                        documentSide ? " \u00B7 ".concat(documentSide) : ''))),
            React.createElement("div", { className: "document-capture-frame", ref: documentCaptureFrameRef },
                React.createElement("div", { "aria-hidden": "true", className: "document-capture-corners" },
                    React.createElement("span", { className: "document-capture-corner--top-left" }),
                    React.createElement("span", { className: "document-capture-corner--top-right" }),
                    React.createElement("span", { className: "document-capture-corner--bottom-left" }),
                    React.createElement("span", { className: "document-capture-corner--bottom-right" })),
                React.createElement("p", { className: "document-capture-instruction" }, t(isSingleSubmission ? 'decision.preSubmitSingleHeading' : 'image.captureInstruction')),
                React.createElement("div", { className: "document-capture-hint" },
                    React.createElement(RiBankCardLine, { "aria-hidden": "true" }),
                    React.createElement("span", null, t(isSingleSubmission ? 'decision.preSubmitSingleCaption' : 'image.captureHint')))),
            React.createElement("footer", { className: "document-capture-footer" },
                React.createElement("div", { className: "document-capture-control document-capture-control--start" }, (currentField === null || currentField === void 0 ? void 0 : currentField.uploads) && (React.createElement(CustomImageButton, { className: "document-capture-file-control" },
                    React.createElement("input", { "aria-label": t('image.captureFile'), disabled: loading || !cameraLoaded, type: "file", accept: Object.keys(fileFormats).filter(function (a) { var _a; return (_a = currentField.uploads) === null || _a === void 0 ? void 0 : _a.includes(fileFormats[a]); }).join(', '), style: { display: 'none' }, onChange: function (e) { return handleFile(e); }, capture: false }),
                    React.createElement("span", { className: "document-capture-control-icon" },
                        React.createElement(RiUpload2Line, { "aria-hidden": "true" })),
                    React.createElement("span", null, t('image.captureFile'))))),
                React.createElement("div", { className: "document-capture-control document-capture-control--center" },
                    React.createElement("button", { type: "button", className: "document-capture-photo-control", "aria-label": t('selfie.takePhoto'), onClick: capture, disabled: loading || !cameraLoaded }),
                    React.createElement("span", null, t('selfie.takePhoto'))),
                React.createElement("div", { className: "document-capture-control document-capture-control--end" },
                    React.createElement("button", { type: "button", className: "document-capture-switch-control", "aria-label": t('image.captureSwitch'), onClick: function () { return tryNextCamera(true); }, disabled: loading || !cameraLoaded || availableCameras.length < 2 },
                        React.createElement(RiRefreshLine, { "aria-hidden": "true" })),
                    React.createElement("span", null, t('image.captureSwitch'))),
                React.createElement("p", { className: "document-capture-footer-note" }, t('common.secureEnvironment')))));
    };
    var renderDocumentsMargin = function () {
        var _a, _b, _c, _d, _e;
        if (isDocumentCameraActive()) {
            return null;
        }
        var fieldText = (_b = (_a = form === null || form === void 0 ? void 0 : form.steps[step]) === null || _a === void 0 ? void 0 : _a.fields[field]) === null || _b === void 0 ? void 0 : _b.field;
        if (fieldText) {
            if (fieldText.includes('rg') || fieldText.includes('rne') || fieldText.includes("oab")) {
                return (React.createElement(DocumentMarginContainer, null,
                    React.createElement(DocumentMargin, { documentDimensions: marginStyle, isMobile: isMobile, "$status": framingState },
                        React.createElement(DocumentLabelRotated, null, (_c = form.steps[step]) === null || _c === void 0 ? void 0 : _c.fields[field ? field : 0].label))));
            }
            if (fieldText.toLowerCase().includes('single_identification_document')) {
                return (React.createElement(DocumentMarginContainer, null,
                    React.createElement(DocumentMargin, { documentDimensions: marginStyle, isMobile: isMobile, "$status": framingState },
                        React.createElement(DocumentSideContainer, null,
                            React.createElement(DocumentLabel, null, t('image.front'))),
                        React.createElement(DocumentSidesDivider, null),
                        React.createElement(DocumentSideContainer, null,
                            React.createElement(DocumentLabel, null, t('image.back'))))));
            }
            if (fieldText.includes('cnh')) {
                return (React.createElement(DocumentMarginContainer, null,
                    React.createElement(DocumentMargin, { documentDimensions: marginStyle, isMobile: isMobile, "$status": framingState },
                        React.createElement(DocumentSideContainer, null,
                            React.createElement(DocumentLabel, null, t('image.front'))),
                        React.createElement(DocumentSidesDivider, null),
                        React.createElement(DocumentSideContainer, null,
                            React.createElement(DocumentLabel, null, t('image.back'))))));
            }
        }
        ;
        return (React.createElement(DocumentMarginContainer, null,
            React.createElement(DocumentMargin, { documentDimensions: marginStyle, isMobile: isMobile, "$status": framingState },
                React.createElement(DocumentLabelRotated, null, ((_e = (_d = form.steps[step]) === null || _d === void 0 ? void 0 : _d.fields[field ? field : 0]) === null || _e === void 0 ? void 0 : _e.label) || t('image.document')))));
    };
    var handleUserMediaError = function (error) {
        console.error('Camera error:', error);
        // Stop any existing tracks first
        stopAllTracks();
        if ((error === null || error === void 0 ? void 0 : error.name) === 'OverconstrainedError' && !useBasicCameraConstraints) {
            setDeviceId(null);
            setUseBasicCameraConstraints(true);
            setCameraAttempt(function (attempt) { return attempt + 1; });
            return;
        }
        var message = (error === null || error === void 0 ? void 0 : error.name) === 'NotAllowedError' || (error === null || error === void 0 ? void 0 : error.name) === 'SecurityError'
            ? t('camera.enableMessage')
            : (error === null || error === void 0 ? void 0 : error.name) === 'NotFoundError' ? t('camera.notFoundMessage') : t('camera.retryAccess');
        setCameraFailure(message);
        var detail = typeof error === 'string' ? error : "".concat((error === null || error === void 0 ? void 0 : error.name) || 'Erro desconhecido', ": ").concat((error === null || error === void 0 ? void 0 : error.message) || '');
        window.alert("".concat(t('camera.failureTitle'), "\n").concat(message, "\n").concat(detail));
        setCameraLoaded(false);
        setCameraPermission(false);
    };
    React.useEffect(function () {
        handleCamera();
        return function () {
            stopAllTracks();
        };
    }, []);
    React.useEffect(function () {
        if (isLandscape) {
            setMarginStyle({
                width: window.innerHeight * 0.95,
                height: (window.innerHeight * 0.95) / 0.72
            });
        }
        else {
            if (isMobile) {
                setMarginStyle({
                    height: window.innerHeight * 0.65,
                    width: (window.innerHeight * 0.65) * 0.72,
                });
            }
            else {
                var maxHeigthDesk = (window.innerHeight * 0.88) - 143 - 2 * 12;
                var maxWidthDesk = maxHeigthDesk * 276.72 / 385;
                setMarginStyle({
                    width: maxWidthDesk,
                    height: maxHeigthDesk,
                });
            }
        }
    }, [isLandscape]);
    useEffect(function () {
        if (!image) {
            autoSubmittedImage.current = null;
            return;
        }
        if (loading || documentSubmitInFlight.current || autoSubmittedImage.current === image)
            return;
        autoSubmittedImage.current = image;
        void sendPhoto();
    }, [image, loading]);
    if (image) {
        return (React.createElement(OnboardingShell, null,
            React.createElement(OnboardingFrame, null,
                React.createElement(ToastContainer, null),
                React.createElement(OnboardingHeader, { logo: theme.logo, hideLogo: theme.logoPosition === 'none' }),
                React.createElement("main", { style: { position: 'relative', minHeight: '16rem' }, "aria-busy": !submissionFailed }, submissionFailed ? React.createElement(React.Fragment, null,
                    React.createElement("p", { role: "alert" }, t('image.reviewBackendError')),
                    React.createElement(OnboardingPrimaryButton, { onClick: function () { void sendPhoto(); } }, t('image.reviewBackendRetry'))) : React.createElement(CaptureLoading, { label: t('image.reviewBackendReading') })),
                React.createElement(OnboardingSecurityFooter, { text: t('common.secureEnvironment') }))));
    }
    if (cameraFailure) {
        return React.createElement(CameraError, { message: cameraFailure, onRetry: handleCamera, retrying: false, cameraNotFound: false, cameraPermission: false, setRetrying: setRetryPermission, setCameraPermission: setCameraPermission });
    }
    return (React.createElement(ImageStepContainer, { isLandscape: isLandscape, screenWidth: window.innerWidth, screenHeight: window.innerHeight },
        React.createElement(Container, null,
            React.createElement(ToastContainer, null),
            foundCamera !== null && (React.createElement(React.Fragment, null, cameraPermission ? (React.createElement(React.Fragment, null,
                React.createElement(CameraContainer, { retrying: retryPermission, isLandscape: isLandscape },
                    React.createElement(Loading, { color: theme.backgroundColor, height: 1, width: 1, className: "hidden-spinner" }),
                    React.createElement(CameraWrapper, { "$isLandscape": isLandscape, "$screenWidth": window.innerWidth, "$screenHeight": window.innerHeight },
                        React.createElement(Camera, { key: cameraAttempt, audio: false, ref: webcamRef, screenshotQuality: 1, forceScreenshotSourceSize: true, screenshotFormat: "image/png", onUserMediaError: handleUserMediaError, onUserMedia: function (stream) {
                                var _a;
                                try {
                                    setCameraLoaded(true);
                                    setRetryPermission(false);
                                    navigator.mediaDevices.enumerateDevices().then(function (devices) {
                                        setAvailableCameras(devices.filter(function (device) { return device.kind === 'videoinput'; }));
                                    }).catch(function () { });
                                    var track = stream.getVideoTracks()[0];
                                    var focusModes = (_a = track === null || track === void 0 ? void 0 : track.getCapabilities) === null || _a === void 0 ? void 0 : _a.call(track).focusMode;
                                    var focusMode = (focusModes === null || focusModes === void 0 ? void 0 : focusModes.includes('continuous')) ? 'continuous'
                                        : (focusModes === null || focusModes === void 0 ? void 0 : focusModes.includes('single-shot')) ? 'single-shot' : undefined;
                                    if (focusMode) {
                                        track.applyConstraints({ advanced: [{ focusMode: focusMode }] }).catch(function () {
                                            // Optional focus tuning must not prevent capture.
                                        });
                                    }
                                }
                                catch (err) {
                                    var errorMessage = err instanceof Error ? err.message : 'unknown error';
                                    toast.error(t('camera.accessError', { message: errorMessage }));
                                    console.error('onUserMedia: ', err);
                                }
                            }, "$topNavigationHeight": (((_f = topNavigationRef.current) === null || _f === void 0 ? void 0 : _f.offsetHeight) || 0), "$isMobile": isMobile, "$isLandscape": isLandscape, "$marginHeight": marginStyle.height, "$marginWidth": marginStyle.width, videoConstraints: useBasicCameraConstraints ? true : __assign({ facingMode: deviceId ? undefined : "environment", width: { ideal: 1920 }, height: { ideal: 1080 } }, (deviceId && { deviceId: { exact: deviceId } })) })),
                    renderDocumentCaptureOverlay(),
                    renderDocumentsMargin(),
                    !isDocumentCameraActive() && (React.createElement(React.Fragment, null,
                        framingHintKey && (React.createElement(FramingHintContainer, { isMobile: mobileView, marginHeight: marginStyle.height },
                            React.createElement(FramingHintText, null, t(framingHintKey)))),
                        React.createElement(ButtonContainer, { isMobile: mobileView, marginHeight: marginStyle.height, marginWidth: marginStyle.width, topNavigationHeight: ((_g = topNavigationRef.current) === null || _g === void 0 ? void 0 : _g.offsetHeight) || 0 },
                            React.createElement(StartButton, { text: t('selfie.takePhoto'), onClick: capture, disabled: loading || !cameraLoaded, loading: loading }),
                            availableCameras.length > 1 && (React.createElement(SwitchCameraButton, { text: t('camera.switchCamera'), onClick: function () { return tryNextCamera(true); }, disabled: loading })),
                            ((_h = form.steps[step]) === null || _h === void 0 ? void 0 : _h.fields[field]) && ((_j = form.steps[step]) === null || _j === void 0 ? void 0 : _j.fields[field].uploads) && (React.createElement(CustomImageButton, null,
                                React.createElement("input", { type: "file", accept: Object.keys(fileFormats).filter(function (a) { var _a, _b; return (_b = (_a = form.steps[step]) === null || _a === void 0 ? void 0 : _a.fields[field].uploads) === null || _b === void 0 ? void 0 : _b.includes(fileFormats[a]); }).join(', '), style: { display: 'none' }, onChange: function (e) { return handleFile(e); }, capture: false }),
                                t('image.searchDigitalDocument'))))))))) : (React.createElement(CameraError, { retrying: retryPermission, cameraNotFound: !foundCamera, setRetrying: setRetryPermission, cameraPermission: cameraPermission, setCameraPermission: setCameraPermission })))),
            ((changingDocumentSide && !cameraFailure && cameraPermission && !retryPermission) || loading || (foundCamera === true && cameraPermission && !cameraLoaded && !retryPermission)) && (React.createElement(CaptureLoading, { opaque: changingDocumentSide, label: changingDocumentSide ? t('image.preparingNextSide') : loading ? t('image.processingDocument') : t('common.loading') })))));
};
export default StepImage;
